import React, { useMemo } from 'react';
import { useConfiguration } from '../../context/configurationContext';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { useTranslatedAssets } from '../../hooks/useTranslatedAssets';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();
  
  // Get current language from Redux state
  const { language } = useSelector(state => state.ui || {});
  const currentLocale = language || 'en';
  
  // Prepare assets for translation
  const assetsToTranslate = useMemo(() => {
    if (!footer || Object.keys(footer).length === 0 || typeof footer === 'string') {
      return {};
    }
    
    // Pass footer content directly, not wrapped in {path, data}
    return {
      footer: footer
    };
  }, [footer]);

  // Use the translation hook (ShareGardens pattern)
  const { translatedAssets, loading } = useTranslatedAssets(
    assetsToTranslate,
    currentLocale,
    {
      enabled: currentLocale !== 'en',
      cacheTime: 30 * 60 * 1000 // 30 minutes
    }
  );

  // Use translated footer or fall back to original
  const finalFooter = (currentLocale !== 'en' && translatedAssets?.footer) 
    ? translatedAssets.footer 
    : footer;

  // If footer asset is not set, let's not render Footer at all.
  if (!finalFooter || Object.keys(finalFooter).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...finalFooter,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return <SectionBuilder sections={[footerSection]} />;
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
